module.exports = __webpack_public_path__ + "static/media/c5.996e8c65.gif";